import { Avatar, Box, ButtonBase, Typography } from '@mui/material'
import { useAuth } from 'contexts/auth'
import { formatCNPJ } from 'utils/is-valid-cnpj'
import { getRGBA } from 'utils/color'
import { useStyles } from './styles'

interface IChangeOrganizationButton {
  organizationName: string
  organizationFederalTaxId: string
  organizationType: string
  eSocialStatus: boolean
  showESocialChip: boolean
  handleChangeOrg: () => void
}

const getOrganizationTypeColor = (orgType: string): string => {
  const normalizedType = orgType.toLowerCase()

  if (normalizedType.includes('buyer') || normalizedType === 'rh') {
    return '#1976d2' // Blue for RH/Buyer
  } else if (normalizedType.includes('seller') || normalizedType === 'corretora') {
    return '#9c27b0' // Purple for Corretora/Seller
  } else if (normalizedType.includes('conducco')) {
    return '#2e7d32' // Green for Conducco
  } else if (normalizedType.includes('supplier')) {
    return '#f57c00' // Orange for Supplier
  }

  return '#1976d2' // Default blue
}

const getOrganizationTypeLabel = (orgType: string): string => {
  const normalizedType = orgType.toLowerCase()

  if (normalizedType.includes('buyer')) {
    return 'RH'
  } else if (normalizedType.includes('seller')) {
    return 'Corretora'
  }

  return orgType // Return original for other types
}

const ChangeOrganizationButton = ({
  organizationName,
  organizationFederalTaxId,
  organizationType,
  eSocialStatus,
  showESocialChip,
  handleChangeOrg,
}: IChangeOrganizationButton) => {
  const classes = useStyles()

  const { user } = useAuth()

  const orgTypeColor = getOrganizationTypeColor(organizationType)
  const orgTypeLabel = getOrganizationTypeLabel(organizationType)

  return (
    <ButtonBase
      onClick={handleChangeOrg}
      className={
        user &&
        user.organization?.name === organizationName &&
        formatCNPJ(user.organization.cnpj as string) === organizationFederalTaxId
          ? classes.buttonBaseSelected
          : classes.buttonBase
      }
    >
      <Box className={classes.container}>
        <Box className={classes.orgContainer}>
          <Avatar sx={{ background: '#BDBDBD', width: '2.5rem', height: '2.5rem' }}>OP</Avatar>
          <Box className={classes.nameAndCnpjContainer}>
            <Typography className={classes.orgName}>{organizationName}</Typography>
            <Typography className={classes.orgCnpj}>{organizationFederalTaxId}</Typography>
          </Box>
        </Box>

        <Box className={classes.chipsContainer}>
          <Box
            className={classes.orgTypeContainer}
            sx={{
              backgroundColor: getRGBA(orgTypeColor, 0.1)
            }}
          >
            <Typography
              className={classes.orgType}
              sx={{ color: orgTypeColor }}
            >
              {orgTypeLabel}
            </Typography>
          </Box>

          {showESocialChip && (
            <Box className={eSocialStatus ? classes.eSocialContainerConnected : classes.eSocialContainerPending}>
              <Typography className={eSocialStatus ? classes.eSocialConnected : classes.eSocialPending}>
                {eSocialStatus ? 'eSocial autenticado' : 'eSocial não autenticado'}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </ButtonBase>
  )
}

export default ChangeOrganizationButton
